<template>
  <div class="container">
    <div class="ui three cards">
      <a class="red raised card" href="/admin/machines">
        <div class="image">
          <i class="red huge icon configure"></i>
        </div>
        <div class="content">
          <div class="header">Machines</div>
          <div class="description">
            Manage Machines
          </div>
        </div>
      </a>
      <a class="orange raised card" href="/admin/assembly">
        <div class="image">
          <i class="orange huge icon configure"></i>
        </div>
        <div class="content">
          <div class="header">Assembly</div>
          <div class="description">
            Manage Assemblies
          </div>
        </div>
      </a>
      <a class="orange raised card" href="/admin/subassembly">
        <div class="image">
          <i class="orange huge icon configure"></i>
        </div>
        <div class="content">
          <div class="header">Sub Assembly</div>
          <div class="description">
            Manage Sub Assemblies
          </div>
        </div>
      </a>
      <a class="yellow raised card" href="/admin/parts">
        <div class="image">
          <i class="yellow huge icon setting"></i>
        </div>
        <div class="content">
          <div class="header">Parts</div>
          <div class="description">
            Manage Parts
          </div>
        </div>
      </a>
      <a class="olive raised card" href="/admin/wear">
        <div class="image">
          <i class="olive huge icon setting"></i>
        </div>
        <div class="content">
          <div class="header">Wear Parts</div>
          <div class="description">
            Manage Wear Parts
          </div>
        </div>
      </a>
      <a class="green raised card" href="/admin/company">
        <div class="image">
          <i class="green huge icon building outline"></i>
        </div>
        <div class="content">
          <div class="header">Companies</div>
          <div class="description">
            Manage Companies and Company Machines
          </div>
        </div>
      </a>
      <a class="teal raised card" href="/admin/users">
        <div class="image">
          <i class="teal huge icon users"></i>
        </div>
        <div class="content">
          <div class="header">Users</div>
          <div class="description">
            Manage Users, Roles, User Companies
          </div>
        </div>
      </a>
      <a class="blue raised card" href="/admin/emailmanagement">
        <div class="image">
          <i class="blue huge icon envelope"></i>
        </div>
        <div class="content">
          <div class="header">Email Management</div>
          <div class="description">
            Manage Email Messages
          </div>
        </div>
      </a>
      <a class="purple raised card" href="/admin/contentblocks">
        <div class="image">
          <i class="purple huge icon block layout"></i>
        </div>
        <div class="content">
          <div class="header">Content Blocks</div>
          <div class="description">
            Manage Content Blocks
          </div>
        </div>
      </a>
      <a class="pink raised card" href="/admin/pages">
        <div class="image">
          <i class="pink huge icon file text"></i>
        </div>
        <div class="content">
          <div class="header">Pages</div>
          <div class="description">
            Manage Pages
          </div>
        </div>
      </a>
      <a class="violet raised card" href="/admin/settings">
        <div class="image">
          <i class="violet huge icon settings"></i>
        </div>
        <div class="content">
          <div class="header">Settings</div>

          <div class="description">
            Manage System Settings
          </div>
        </div>
      </a>
      <a class="brown raised card" href="/admin/navigation">
        <div class="image">
          <i class="brown huge icon browser"></i>
        </div>
        <div class="content">
          <div class="header">Navigation</div>
          <div class="description">
            Manage Navigation Menus
          </div>
        </div>
      </a>
      <a class="black raised card" href="/admin/errors">
        <div class="image">
          <i class="black huge icon bug"></i>
        </div>
        <div class="content">
          <div class="header">Error Log</div>
          <div class="description">
            View Error Logs
          </div>
        </div>
      </a>
      <a class="red raised card" href="/admin/sequence">
        <div class="image">
          <i class="red huge icon sort numeric down"></i>
        </div>
        <div class="content">
          <div class="header">Sequence</div>
          <div class="description">
            Manage Sequence
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminIndex",
  computed: {},
  data() {
    return {
      users: [],
      admin: true,
    };
  },
  mounted() {},
  methods: {},
};
</script>
